import type { SchemaBuilderSelectFormValue } from "./schema-builder-select.type";
import type {
  SchemaFieldSelect,
  SchemaFieldSelectValue,
  SchemaFieldSelectValueLegacy,
} from "@/entities/schema";

import {
  getConditionsFormValuesFromSchema,
  getSchemaConditionsFromValues,
} from "../schema-builder-condition";

export const getSelectValuesFromSchema = (
  schema: SchemaFieldSelect
): SchemaBuilderSelectFormValue[] => {
  if (!schema.values?.length) return [];

  if (typeof schema.values[0] === "string") {
    const values = schema.values as SchemaFieldSelectValueLegacy[];
    return [{ values: values ?? [], conditions: [] }];
  }

  const values = schema.values as SchemaFieldSelectValue[];

  return values.map((value): SchemaBuilderSelectFormValue => ({
    values: value.values ?? [],
    conditions: getConditionsFormValuesFromSchema(value.conditions),
  }));
};

export const getSchemaSelectValuesFromValues = (
  formValues?: SchemaBuilderSelectFormValue[]
): SchemaFieldSelectValue[] => {
  if (!formValues?.length) return [];

  return formValues.map(getSchemaSelectValueFromValue);
};

export const getSchemaSelectValueFromValue = (
  selectValue: SchemaBuilderSelectFormValue
): SchemaFieldSelectValue => {
  return {
    values: selectValue.values,
    conditions: getSchemaConditionsFromValues(selectValue.conditions),
  };
};
